<ng-content></ng-content>
<span a3l-ui-button-spinner *ngIf="processing"></span>
